import { useRouteLocation } from 'react-router-stack';
import React, { useEffect, useState } from 'react';
import { isSmartPhone } from '../../../utilities/helper';
import PreviewAnswerListMWeb from './index_mWeb';
import PreviewAnswerListWeb from './index_web';

const PreviewAnswerList = () => {
  const { state = {} } = useRouteLocation();
  const [finalAnswerList, setFinalAnswerList] = useState([]);
  const { teamName = '', score = 0, questionList, answerList = [], item } = state;
  const { teamA, teamB } = item;

  useEffect(() => {
    let list = [] as any;

    let adminAnswered = false;
    answerList.forEach((item: any) => {
      const questionItem = questionList[item.questionId];
      if (questionItem) {
        const {
          imageUrl = '',
          questions = {},
          insights = '',
          sequence = 1,
          answer: adminAnswer = false,
          isAnswered = false
        } = questionItem;
        if (!adminAnswered) adminAnswered = isAnswered;
        const { answer: userAnswer = false } = item;
        list.push({
          ...item,
          imageUrl,
          questions,
          insights,
          sequence,
          isAnswered,
          answerStatus: adminAnswer === userAnswer
        });
      }
    });
    list.sort((a: { sequence?: 0 | undefined }, b: { sequence?: 0 | undefined }) => {
      const { sequence: a_sequence = 0 } = a;
      const { sequence: b_sequence = 0 } = b;
      return a_sequence > b_sequence ? 1 : -1;
    });
    setFinalAnswerList(list);
  }, []);

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <PreviewAnswerListMWeb
          score={score}
          teamName={teamName}
          finalAnswerList={finalAnswerList}
        />
      ) : (
        <PreviewAnswerListWeb
          score={score}
          teamA={teamA}
          teamB={teamB}
          finalAnswerList={finalAnswerList}
        />
      )}
    </React.Fragment>
  );
};
export default PreviewAnswerList;
